module.exports = __webpack_public_path__ + "img/3L.002c6725.png";